import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ErrorStore } from '@cxc/core/services';

import { NgIconComponent } from '@ng-icons/core';


@Component({
  selector: 'error-small-component',
  templateUrl: './error-small.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, NgIconComponent],
})
export class ErrorSmallComponent {
  errorStore = inject(ErrorStore);
}
